var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"name":"Notification"}},[_c('VSystemMessage',{attrs:{"primaryText":"Reset Password"}},[_c('div',{staticClass:"reset-password"},[_c('VForm',{attrs:{"name":_vm.name,"fields":_vm.fields,"submitButton":{
          label: 'Change password',
          classType: 'primary giant'
        },"disabled":_vm.isLoading},on:{"submit":_vm.onSubmit}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }